import React from 'react';
import { Paper, Box, Divider, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Backdrop, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import EmailIcon from '@material-ui/icons/Email';
import { Edit } from '@material-ui/icons';
import axios_instance from '../../../services/auth/jwt/config';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
    paperRoot: { height: '100%' },
    cardRoot: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    textGrey: {
        color: 'rgba(0, 0, 0, 0.5)',
    },
}));

const RequestCard = ({ protocol, theme, subject, service, description }) => {
    const [openEdit, setOpenEdit] = React.useState(false);
    const [newDescription, setNewDescription] = React.useState(description.split('<br />').join('\n'));
    const [saving, setSaving] = React.useState(false);
    const userAccess = useSelector(({ auth }) => (auth.authUser ? auth.authUser.cargo.interno : null));
    const { enqueueSnackbar } = useSnackbar();
    const classes = useStyles();

    const onSave = () => {
        setSaving(true);
        axios_instance.post(`ouvidoria/ocorrencia/descricao/update/${protocol.replace('#', '')}`, {
            descricao: newDescription
        }).then(res => {
            if (res?.data?.success) {
                enqueueSnackbar('Descrição atualizada com sucesso!', { variant: 'success' });
            } else {
                enqueueSnackbar(res.data.message, { variant: 'error' });
            }
        }).catch(err => {
            enqueueSnackbar('Erro ao atualizar descrição!', { variant: 'error' });
        }).finally(() => {
            setSaving(false);
            setOpenEdit(false);
        })
    }

    return <Paper className={classes.paperRoot}>
        <Backdrop open={saving} style={{ zIndex: 9999 }}>
            <Box display="flex" justifyContent="center" alignItems="center" color="white">
                <CircularProgress color="inherit" />
                <Box ml={2}>Salvando...</Box>
            </Box>
        </Backdrop>
        <Box className={classes.cardRoot} py={2} px={4}>
            <Box>
                <Box display="flex" alignItems="center" my={2}>
                    <EmailIcon fontSize="small" />
                    <Box ml={2} fontWeight={500}>
                        Solicitação
                    </Box>
                </Box>
                <Box mb={2}>
                    <Divider />
                </Box>
            </Box>
            <Box mb={2}>
                <Box fontWeight={700} fontSize={14} mb={1}>
                    Protocolo:
                </Box>
                <Box>{protocol}</Box>
            </Box>
            <Box mb={2}>
                <Box fontWeight={700} fontSize={14} mb={1}>
                    Assunto:
                </Box>
                <Box display="flex">
                    <Box fontWeight={400} className={classes.textGrey}>
                        {theme} /
                    </Box>
                    <Box fontWeight={500} className={classes.textGrey} ml={1}>
                        {subject} /
                    </Box>
                    <Box fontWeight={500} ml={1}>
                        {service}
                    </Box>
                </Box>
            </Box>
            <Box mb={2}>
                <Box fontWeight={700} fontSize={14} mb={1} display="flex" justifyContent="space-between" alignItems="center">
                    Descrição:
                    {userAccess === 'ouvidor' || userAccess === 'admin' ? <IconButton
                        onClick={() => {
                            setOpenEdit(true);
                        }}
                    >
                        <Edit fontSize='small' />
                    </IconButton> : null}
                </Box>
                <Box>
                    {description.split('<br />').map((item, index) => (
                        <Box key={index}>{item}</Box>
                    ))}
                </Box>
            </Box>
        </Box>
        <Dialog open={openEdit} onClose={() => setOpenEdit(false)} fullWidth maxWidth="lg">
            <DialogTitle>
                Editar Ocorrência
            </DialogTitle>
            <DialogContent>
                <TextField
                    label="Descrição"
                    multiline
                    minRows={4}
                    fullWidth
                    variant="outlined"
                    value={newDescription}
                    onChange={(e) => setNewDescription(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Box display="flex" justifyContent="space-between" width="100%">
                    <Button variant="contained" color="secondary" onClick={() => setOpenEdit(false)}>
                        Cancelar
                    </Button>
                    <Button variant="contained" color="primary" disabled={newDescription === description.split('<br />').join('\n')} onClick={onSave}>
                        Salvar
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    </Paper>
};

export default RequestCard;
